<section>
    <div class="title">
        <h2 class="unl-plan-type" >{{ pageData.selectionPage.planName }}</h2>
    </div>
    <!-- Displaying promo container temp. Needs to be replaced post CEUIDSS-29611 & CEUIDSS-29620 completion -->
    <xm-switch-banner
        *ngIf="showSegmentUpgradeBanner && segmentSwitchBanner"
        [imageOptions]="segmentSwitchIcon"
        [header]="segmentSwitchBanner?.header"
        [description]="segmentSwitchBanner?.body"
        [cta]="segmentSwitchBanner?.cta">
    </xm-switch-banner>
    <xm-plan-switch-promotions 
            *ngIf="isDiscountPromotion && !isIcopPlanSwitch"
            [isBogoPromoLossForUnl]="showBogoPromoLossForUnlLines"
            [promotionType]="promotionType"
            [promotionContent]="promoContent"
            [BYOPromoContent]="promoBYOContent"
            [UNLPromoContent]="promoUNLContent"
            [extendedPromoContent]="extendedPromoContent"
            [tradeInDDAPromoContent]="tradeInDDAPromoContent">
    </xm-plan-switch-promotions>
        <xm-icop-plan-switch-promotions *ngIf="isIcopPlanSwitch"></xm-icop-plan-switch-promotions>
    <div class="header">{{ pageData.selectionPage.header }}</div>
        <div class="features">
            <div class="icon-border">
                <div class="icon">
                    <span class="icon-content">
                        <span class="data-text">{{ btgPlan.price }}</span>
                    </span>
                    <span class="data-subhead">
                        {{ btgPlan.type }}
                    </span>
                </div>
            </div>
            <div class="features-details">
                <table class="features-table">
                    <tr *ngFor="let feature of cmsPageData; let i = index">
                        <td>
                            <xm-media-image aria-hidden="true" class="plan-feature-icon icon-resize"
                                [imageOptions]="getMediaImageOptions(feature.icon)"></xm-media-image>
                        </td>
                        <td>
                            <p class="body">{{ btgPlan.points[i] }}</p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="buttons">
            <button class="xm-btn-link-light cancel" (click)="onCancel()">{{ pageData.selectionPage.ctas.cancel }}</button>
            <button class="xm-btn-primary-dark" (click)="navToSwitchInProgress()">{{ switchCta }}</button>
        </div>
</section>
